var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#F5D447"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.908 47.1197C106.119 43.2934 99.9776 43.2934 96.1883 47.1197L61.8855 81.6739L53.3117 73.0353C49.5224 69.2325 43.3788 69.2325 39.5919 73.0353C35.8027 76.8616 35.8027 83.0588 39.5919 86.8616L55.0269 102.425C58.8162 106.251 64.9573 106.251 68.7465 102.425L109.908 60.946C113.697 57.1197 113.697 50.9225 109.908 47.1197Z",
    fill: "#695BD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentConfirmed);
export default __webpack_public_path__ + "static/media/paymentConfirmed.8313e186cd56934ee13d9b9be540be06.svg";
export { ForwardRef as ReactComponent };